const SavingsSetupIntro ={

    summaryText: 
        "One way to set money aside is to move it from a checking account 'Cash' to a savings account. " +
        "This has advantages because the money in a savings account earns interest. ",
   
    moreInformation:
        "If you don’t have enough cash to cover your monthly bills, your balance " +
        "can go negative — putting your game progress at risk. " +
        "In that case, you can transfer money from your savings back to your cash  " +
        "(checking) account. But be careful: depending on your account type, this " +
        "might come with a costly penalty.  Plan your savings wisely. Make sure you " +
        "leave enough cash — and income — to handle surprise expenses."
                      
}

export default SavingsSetupIntro;